import Icon from './Icon'
export default Icon
export type { IIcon } from './Icon.types'
export * from './Icons'
